<template>
  <span>
    <span class="mr-2">{{ segmentsLabel }}</span>

    <a-tooltip
      placement="right"
      :get-popup-container="getPopupContainer"
      :overlayStyle="{
        whiteSpace: 'normal',
        minWidth: '300px',
        maxWidth: 'none'
      }"
    >
      <template #title>
        <span>To work with segments, go to control panel:</span>

        <a
          :href="segmentsLink"
          target="_blank"
          class="d-block text-primary"
        >
          {{ segmentsLink }}
        </a>
      </template>

      <a-icon class="text-primary" type="info-circle" />
    </a-tooltip>
  </span>
</template>

<script>
export default {
  name: 'SegmentLabel',
  props: {
    isViewscreen: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    segmentsLabel() {
      return this.isViewscreen ? 'Segment' : 'Segments'
    },
    segmentsLink() {
      const apiUrl = process.env.VUE_APP_API_URL

      const map = {
        'https://api.ocms.dev/api': 'https://admin.segmenter.olimp.mobi',
        'https://api.ragnaros.net/api': 'https://admin.segmenter.ragnaros.net',
      }

      return map[apiUrl] || 'https://admin.segmenter.dev.olimp.mobi/'
    },
  },

  methods: {
    getPopupContainer() {
      return document.body
    },
  },
}
</script>
